export default __webpack_public_path__ + "static/media/bookworm-yellow.4bf8b126.svg";